import styled from '@emotion/styled';
import Button from '../../common/Button';

export const Container = styled.div`
  padding: 25px 2px;
`;

export const FlexWrapper = styled.div`
  display: flex;
`;

export const ItemPhotoWrapper = styled.div`
  padding-top: 10px;
  margin-right: 17px;
`;

export const ItemDetails = styled.div`
  width: 75%;
  padding-left: 17px;
`;

export const ItemName = styled.div`
  height: fit-content;
  width: 100%;
  display: ${({ inline }) => (inline ? 'flex' : 'block')};
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const ButtonGroup = styled.div`
  width: 467px;
  margin-top: auto;
`;

// Item Info
export const ItemInfoContainer = styled.div`
  flex-shrink: 0;
  padding: 20px 0;
  ${({paddingTop})=> paddingTop && 'padding-top: 48px;'}
  width: ${({ width }) => width || '100%'};
`;

export const CollapseButton = styled.button`
  text-align: left;
  border: none;
  width: 90px;
  background: transparent;
  cursor: pointer;
  margin-bottom: 20px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.blueMed};
`;

export const SubTitle = styled.span`
  font-family: 'Heebo-Bold';
  font-size: ${({ theme }) => theme.fontSize.medium};
  display: block;
  margin-bottom: 20px;
`;

export const ActionButton = styled(Button)`
  margin-right: 10px;
`;
